const initialState = {
  athletesData: [],
  isNewRequestFulfill: false
};

const shoutoutsAthlete = (state = initialState, action) => {
  const { payload, type } = action;

  switch (type) {
    case 'ADD_SHOUTOUT_ATHLETES_DATA':
      return {
        ...state,
        athletesData: payload
      };
    case 'UPDATE_NEW_REQUEST_FULFILL_FLAG':
      return {
        ...state,
        isNewRequestFulfill: payload
      };
    default:
      return state;
  }
};

export default shoutoutsAthlete;
